











































































import { Component, Vue } from 'vue-property-decorator';
import { CompanyDetailsModule } from '@/store/modules/companyDetails'
import RateCardDto from '@/models/RateCards/RateCardDto'
import CompanyRateCardPositions from '@/components/RateCardPositions/CompanyRateCardPositions.vue';
import CompanyRateCardCreate from '@/components/RateCards/CompanyRateCardCreate.vue';
import CompanyRateCardEdit from '@/components/RateCards/CompanyRateCardEdit.vue';

@Component({
  name: 'CompanyRateCards',
  components: { CompanyRateCardPositions, CompanyRateCardCreate, CompanyRateCardEdit }
})
export default class extends Vue {
    
    async created() {
        await  CompanyDetailsModule.getRateCards();
    }

    async updateRateCard(rateCard: RateCardDto) {
        CompanyDetailsModule.updateCurrentRateCard(rateCard);
    }

    get currentRateCard() {
        return CompanyDetailsModule.currentRateCard;
    }

    get loadingRateCards() {
        return CompanyDetailsModule.loadingRateCards;
    }

    get rateCards() {
        return CompanyDetailsModule.rateCards;
    }
}
